export const COMPARISON_TABLE_STRINGS = {
  'page.title1': `What's the difference?`,
  'page.subtitle': 'A better way to manage rental homes.',
  'table.header1': 'Traditional Property Management',
  'table.header2': 'Tech Property Management',
};
